import styled from 'styled-components';
import { sizes } from 'style';
import { th } from 'style/theme';

export const StyledProgressBar = styled.div`
  display: none;

  @media ${sizes.desktop} {
    display: flex;
    justify-content: center;
    gap: 6px;
    width: 100%;
  }
`;

export const Step = styled.div<{ $isPast: boolean }>`
  width: 33px;
  height: 8px;
  border-radius: 8px;
  background-color: ${({ $isPast }) =>
    $isPast ? th('colors.fountainBlue') : th('colors.pickledBluewood35')};
  transition: background-color 200ms;
`;
